// eslint-disable-next-line import/no-cycle
import { ListSelectionTypeEnum } from '@/types';
// eslint-disable-next-line import/no-cycle
import { TemplateEditorState } from '@/composables/template-editor/TemplateEditor';
// eslint-disable-next-line import/no-cycle
import { getShopDefaultLang } from '@/composables/User';
// eslint-disable-next-line import/no-cycle
import { TRANSLATION_MARKUP } from '@/components/template-builder/utils/constants';
// eslint-disable-next-line import/no-cycle
import { getTemplateIframeDocument } from '@/components/template-builder/utils/helpers';

interface RcsSmartListConfig {
  [key: string]: any;
}

const DEFAULT_ENGINE = 'crossselling';

/**
 * Get smartlist config from rcs_data[defaultLang].smartlist
 */
const getConfig = (): RcsSmartListConfig => {
  const template = TemplateEditorState.template;
  const configuration = template?.configuration as Record<string, any> | undefined;
  const defaultLang = getShopDefaultLang();
  const rcsData = configuration?.richtexting_data as Record<string, any> | undefined;
  return (rcsData?.[defaultLang]?.smartlist ?? {}) as RcsSmartListConfig;
};

/**
 * Get button text from the hidden source element (which has translation markup)
 */
const getButtonTextFromSource = (selector: string): string => {
  const template = getTemplateIframeDocument();
  if (!template) return 'Voir le produit';

  const container = template.querySelector(selector) as HTMLElement | null;
  if (!container) return 'Voir le produit';

  const source = container.querySelector('.rcs-smartlist-buttontext-source') as HTMLElement | null;
  if (!source) return 'Voir le produit';

  const translationNode = source.querySelector(TRANSLATION_MARKUP) as HTMLElement | null;
  return translationNode?.innerHTML ?? source.textContent ?? 'Voir le produit';
};

export const getRcsSmartListProperty = (selector: string, name: string, widgetId: string): any => {
  const cfg = getConfig();
  
  // For buttonText, read from the hidden source element
  if (name === 'buttonText') {
    return getButtonTextFromSource(selector);
  }
  
  // Default value for engine (selection type)
  if (name === 'engine') {
    return cfg.engine || DEFAULT_ENGINE;
  }
  
  return cfg[name] ?? '';
};

/**
 * Check if the smart list uses a manual product selection. With that selection type the engine returns
 * exactly the selected products, so properties driving the number of returned products (like "nb") are ignored.
 */
export const isRcsSmartListManualSelection = (): boolean => getConfig().engine === ListSelectionTypeEnum.MANUAL_SELECTION;

export const getRcsSmartListDisplayedElements = (selector: string, name: string, widgetId: string): string[] => {
  const cfg = getConfig();
  return Array.isArray(cfg.displayedElements) ? cfg.displayedElements : [];
};

export const getRcsSmartListHtmlCode = (selector: string, name: string, widgetId: string): string => {
  const cfg = getConfig();
  const value = cfg.htmlCode;
  return typeof value === 'string' ? value : '';
};

/**
 * Check if smartlist is enabled by checking the DOM (iframe)
 */
export const isRcsSmartListEnabled = (): boolean => {
  const iframeDoc = getTemplateIframeDocument();
  if (!iframeDoc) return false;
  
  const carousel = iframeDoc.querySelector('.rcs-smartlist-carousel');
  return carousel?.classList.contains('smartlist-enabled') ?? false;
};

/**
 * Check if there are more than 1 CTA in the body message (smartlist cannot be enabled in this case)
 */
export const hasMoreThanOneRcsCta = (): boolean => {
  const iframeDoc = getTemplateIframeDocument();
  if (!iframeDoc) return false;
  
  const ctaListContainer = iframeDoc.querySelector('.rcs-message__cta__list');
  if (!ctaListContainer) return false;
  
  const ctaElements = ctaListContainer.querySelectorAll('.rcs-message__cta__item');
  return ctaElements.length > 1;
};
